<template>
  <div id="app">
    <router-view />

    <footer class="foot">
      <p>Copyright&copy;2005-2020 蜜糖婚戀</p>
    </footer>
  </div>
</template>

<script>
import utils from "@/base/utils";
export default {
  name: "App",
  created() {
    this.$globalData.liveId = utils.getQueryString("liveId") || "";
  }
};
</script>

<style lang="scss">
@import "./styles/base.scss";
@import "./styles/reset.scss";
#app {
  background-color: #fff;
  line-height: px2rem(50px);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  // margin-top: 60px;
}
.foot {
  font-size: px2rem(24px);
  font-family: PingFang SC;
  font-weight: 400;
  margin-top: px2rem(100px);
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/App.vue